module.exports = __webpack_public_path__ + "media/images/mail-envelope-c09c6937.png";